interface Props {
  /** Student value, 0-100. */
  value: number | null;
  /** Class average, 0-100; drawn as a navy tick when present. */
  classValue?: number | null;
  label: string;
  className?: string;
  /** `accent` always fills orange (the Overview "Weakest chapters" bars); `auto` is orange below 50 and slate otherwise. */
  fill?: 'auto' | 'accent';
}

const clamp = (n: number) => Math.max(0, Math.min(100, n));

/** Artboard `.mtrack`: the student's fill (orange below 50, otherwise slate) and a navy tick at the class average (`.mk`). */
export default function CompareBar({ value, classValue = null, label, className = '', fill = 'auto' }: Props) {
  const v = value == null || !Number.isFinite(value) ? 0 : clamp(value);
  const c = classValue == null || !Number.isFinite(classValue) ? null : clamp(classValue);
  const accent = fill === 'accent' || v < 50;
  return (
    <div role="img" aria-label={label} className={`relative h-2 rounded-full bg-track ${className}`}>
      <div className={`h-full rounded-full ${accent ? 'bg-accent' : 'bg-slate'}`} style={{ width: `${v}%` }} />
      {c !== null && (
        <span aria-hidden="true" data-testid="class-tick" className="absolute -top-1 h-4 w-[3px] -translate-x-px rounded-sm bg-navy dark:bg-ink" style={{ left: `${c}%` }} />
      )}
    </div>
  );
}
